import React, { useState } from "react";
import {
  Button,
  Col,
  Container,
  Form,
  Row,
  InputGroup,
  Spinner,
  Alert,
  Image
} from "react-bootstrap";
import { GoEye, GoEyeClosed } from "react-icons/go";
import {
  getAuth,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
} from "firebase/auth";
import { app } from "../../credenciales";
import { NavLink, useNavigate } from 'react-router-dom';
import { Toaster } from "sonner";
import style from './SignUp.module.css';
import { Alert as AlertSonner } from "../../utils";
import imgLogo from "../../assets/images/ifh-logo.png";
import { generateQrCode, sendUserToFirestore } from "../../utils/auxiliarFunctions";

const auth = getAuth(app);

const SignUp = (props) => {
  const [error, setError] = useState("");
  const [userCreated, setUserCreated] = useState(false);
  const [email, setEmail] = useState(props.customerEmail || "");
  const [newUser, setNewUser] = useState({
    password: "",
    coincidentPassword: "",
    active: false,
  });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [fechaNacimiento, setFechaNacimiento] = useState("");

  const navigate = useNavigate();

  const handlePasswordChange = (e) => {
    const name = e.target.name;
    if (name === "password") {
      if (e.target.value.length > 5) {
        setNewUser({ ...newUser, password: e.target.value, active: true });
      } else {
        setNewUser({ ...newUser, password: e.target.value, active: false });
      }
    } else if (name === "coincidentPassword") {
      setNewUser({ ...newUser, coincidentPassword: e.target.value });
    }
  };

  const handleEmailChange = (e) => {
    const emailValue = e.target.value;
    setEmail(emailValue);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const name = e.target.name.value;
    const lastName = e.target.lastName.value;
    const email = e.target.email.value;
    const password = e.target.password.value;
    const fechaNacimiento = e.target.fechaNacimiento.value;
    const numeroSocio = e.target.numeroSocio.value;

    if (email === "") {
      setLoading(false);
      return AlertSonner.error("Tienes que ingresar un correo");
    }

    if (name === "") {
      setLoading(false);
      return AlertSonner.error("Tienes que ingresar un nombre");
    }

    if (lastName === "") {
      setLoading(false);
      return AlertSonner.error("Tienes que ingresar un apellido");
    }

    if (numeroSocio === "") {
      setLoading(false);
      return AlertSonner.error("Tienes que ingresar un número de socio");
    }

    if (fechaNacimiento === "") {
      setLoading(false);
      return AlertSonner.error("Tienes que ingresar una fecha de nacimiento");
    }

    if (password === "") {
      setLoading(false);
      return AlertSonner.error("Tienes que ingresar una contraseña");
    }

    if (password && e.target.coincidentPassword) {
      console.log();
      if (e.target.coincidentPassword.value === "") {
        setLoading(false);
        return AlertSonner.error("Tienes que repetir la contraseña");
      }
      if (e.target.coincidentPassword.value !== password) {
        setLoading(false);
        return AlertSonner.error("Las contraseñas deben ser iguales");
      }
    }

    try {
      const qrCodeURL = await generateQrCode(email);

      await createUserWithEmailAndPassword(auth, email, password);
      
      await sendUserToFirestore(email, name, lastName, numeroSocio, fechaNacimiento, "2", qrCodeURL)

      await signInWithEmailAndPassword(auth, email, password);

      setUserCreated(true);
      navigate(`/login`);

    }
    catch (error) {
      setLoading(false);
      if (error.code === "auth/email-already-in-use") {
        AlertSonner.error("Ya existe una cuenta con ese correo electrónico");
      }
      if (error.code === "auth/missing-password") {
        setError("Tienes que poner una contraseña");
      }
      console.log("Error al crear el usuario: ", error);
    }
  }

  const handleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Container fluid={true} className={style.registerContainer}>
      <Row className='d-flex justify-content-center text-center mb-4'>
        <Col>
          <Image src={imgLogo} className={style.imgLogo} />
        </Col>
      </Row>
      <Row className='d-flex justify-content-center'>
        <Col className={`${style.colContainer}`} md={4} sm={12}>
        <div className="text-center">
          <h3 className={style.title}>¡Registrate para comenzar!</h3>
          <p className={style.text}>Crea una cuenta</p>
        </div>
          <Form onSubmit={handleSubmit} className="mt-4">
            <Form.Group className="mb-3">
              <Form.Control
                type="email"
                placeholder="Email"
                name="email"
                value={props.customerEmail ? props.customerEmail : email}
                onChange={handleEmailChange}
                className={style.formInputs}
              />
            </Form.Group>
            <Row>
              <Col sm={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Nombre"
                    name="name"
                    className={style.formInputs}
                  />
                </Form.Group>
              </Col>
              <Col sm={12} md={6}>
                <Form.Group className="mb-3">
                  <Form.Control
                    type="text"
                    placeholder="Apellido"
                    name="lastName"
                    className={style.formInputs}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Control
                  type="text"
                  placeholder="Número de socio"
                  name="numeroSocio"
                  className={style.formInputs}
                />
              </Form.Group>
            </Col>
            <Form.Group className="mb-3">
              <Form.Label className={style.formLabels}>Fecha de nacimiento</Form.Label>
              <Form.Control
                type="date"
                name="fechaNacimiento"
                value={fechaNacimiento}
                placeholder="Fecha de nacimiento"
                onChange={(e) => setFechaNacimiento(e.target.value)}
                className={style.formInputs}
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <InputGroup>
                <Form.Control
                  isInvalid={
                    newUser.password.length > 0 &&
                    newUser.password.length < 6
                  }
                  type={showPassword ? "text" : "password"}
                  placeholder="Contraseña"
                  name="password"
                  value={newUser.password}
                  onChange={handlePasswordChange}
                  className={style.formInputs}
                />
                {showPassword ? (
                  <Button
                    className={style.showPswBtn}
                    variant="dark"
                    onClick={handleShowPassword}
                  >
                    <GoEye />
                  </Button>
                ) : (
                  <Button
                    className={style.showPswBtn}
                    variant="dark"
                    onClick={handleShowPassword}
                  >
                    <GoEyeClosed />
                  </Button>
                )}
                <Form.Control.Feedback type="invalid">
                  {("Mínimo 6 caracteres")}
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>
            {newUser.password && (
              <Form.Group
                className={`mb-3 ${style.confirmPassword} ${newUser.active && style.confirmPasswordActive
                  }`}
              >
                <Form.Control
                  type="password"
                  placeholder="Repetir contraseña"
                  name="coincidentPassword"
                  value={newUser.coincidentPassword}
                  onChange={handlePasswordChange}
                  isValid={newUser.password === newUser.coincidentPassword}
                  isInvalid={
                    newUser.password !== newUser.coincidentPassword
                  }
                  className={style.formInputs}
                />
                <Form.Control.Feedback>
                  {("Las contraseñas son iguales")}
                </Form.Control.Feedback>
                {newUser.coincidentPassword.length !== 0 && (
                  <Form.Control.Feedback type="invalid">
                    {("Las contraseñas no son iguales")}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            )}
            <Button
              variant="primary"
              type="submit"
              className={style.loginBtn}
            >
              {("Registrarse")}{" "}
              {loading && (
                <Spinner
                  as="span"
                  size="sm"
                  animation="grow"
                  role="status"
                />
              )}
            </Button>
          </Form>
          {userCreated ? (
            <Alert key="secondary" variant="dark" className="mt-4">
              Usuario creado.{" "}
              <NavLink
                to="/login"
                className={style.goToLoginRegisterSuccess}
              >
                Ir a login
              </NavLink>
            </Alert>
          ) : null}
          <div className="text-center mt-4">
            <NavLink to="/login" className={`mt-2 ${style.register}`}>
              {("Ya tenés una cuenta?")}{" "}
              <span className={style.registerSignupTxt}>{("Iniciar Sesión")}</span>
            </NavLink>
          </div>
          <Toaster richColors position="bottom-center" />
        </Col>
      </Row>
    </Container>
  );
};

export default SignUp;
